
import {initActions} from '@dized/ui/dist/redux/ActionHelper';
import {genericActions} from '@dized/ui/dist/redux/OrmHelper';
import {get, patchNoHeader} from '@dized/ui/dist/redux/RequestHelper';
import { post} from '@dized/ui/dist/redux/RequestHelper';

const path = '/api/v1/tutorial';

const apiPath = '/api/v1/tutorial';
const modelName = 'TUTORIAL';

export default initActions('TutorialAction', {
  ...genericActions({modelName}, apiPath),
  FETCH_TUTORIAL: (id, variant, templateName) =>
    get(`${apiPath}/${id}/json`, {variant, templateName}),
  UPDATE_TUTORIAL: (id, attrs) =>
    patchNoHeader(`${apiPath}/${id}`, attrs, null, {id}),
  GET_TUTORIAL_JSON: (uuid) => get(`${path}/${uuid}/json`),
  POST_TUTORIAL: params => post(path, params),
});
